import React from "react";
import img1 from "../../images/gemapi/gally/3.jpg";
import img2 from "../../images/gemapi/gally/4.jpg";

import img3 from "../../images/gemapi/gally/5.jpg";

import map from "../../images/map.jpg";
import map2 from "../../images/map2.png";
import map3 from "../../images/map3.jpg";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import "./carouselAnimation.css";

const GallyHistory = () => {
  const images = [
    { id: 1, img: img1, alt: "Historical landscape of Ru de Gally" },
    { id: 2, img: img2, alt: "Historical landscape of Ru de Gally" },
    { id: 3, img: img3, alt: "Historical landscape of Ru de Gally" },
  ];

  return (
    <div>
      <section
        className="p-4 text-center sm:p-6 md:p-10 lg:p-20 bg-black/70 bg-blend-overlay"
        style={{
          backgroundImage: `url(${map})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-xl font-bold text-center text-white sm:text-2xl md:text-3xl">
          L’historique du ru de Gally
        </h1>
      </section>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-20 sm:px-6 lg:px-8">
        <div className="grid items-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <p className="text-base">
              L’urbanisation engendrée par la construction du château de
              Versailles a petit à petit changé son visage, pour prendre celui
              que nous lui connaissons aujourd’hui. Seul exutoire naturel des
              eaux usées générées par cette urbanisation, le ru s’est
              progressivement vidé de ses habitants, a connu un envasement
              progressif, cause de fréquentes inondations. Dans les années 1960,
              ces dernières ont laissé de mauvais souvenirs aux riverains du ru,
              particulièrement des communes de Rennemoulin, de Thiverval-Grignon
              et de Chavenay en 1965.
            </p>
          </div>
          <div className="flex justify-center">
            <div className="w-full max-w-lg">
              <Carousel
                opts={{ align: "start", loop: true }}
                className="w-full"
              >
                <CarouselContent>
                  {images.map((item) => (
                    <CarouselItem key={item.id}>
                      <div className="flex items-center justify-center w-full h-64 bg-gray-200 rounded-lg sm:h-80 md:h-96">
                        <img
                          src={item.img}
                          alt={item.alt}
                          className="object-cover w-full h-full rounded-lg"
                        />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="absolute flex items-center justify-center border-none  text-white transform -translate-y-1/2 bg-teal-500 rounded-full   left-2 sm:left-4 top-1/2 hover:bg-teal-600" />
                <CarouselNext className="absolute flex items-center justify-center border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full   right-2 sm:right-4 top-1/2 hover:bg-teal-600" />
              </Carousel>
            </div>
          </div>
        </div>
      </div>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <div className="grid items-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="flex justify-center">
            <img
              src={map2}
              alt="Historical map of Ru de Gally"
              className="w-full h-auto max-w-xs rotate-90 rounded-lg sm:max-w-sm"
            />
          </div>
          <div className="text-start">
            <p className="text-base">
              <span className="text-primary">HYDREAULYS</span> a multiplié
              depuis les initiatives afin de protéger les habitants des crues et
              inondations et redonner au ru de Gally sa vitalité naturelle. Un
              grand projet de renaturation a ainsi été lancé.
            </p>
          </div>
        </div>
      </div>

      <div className="">
        <img
          src={map3}
          alt="Modern map of Ru de Gally"
          className="w-full rounded-lg"
        />
      </div>
    </div>
  );
};

export default GallyHistory;
